module.exports = __webpack_public_path__ + "img/content5-2.c2b4387a.webp";